<template>
  <div class="table-date-cell">
    <span v-if="formattedDate" class="text-sm text-neutral-text-weak">
      {{ formattedDate }}
    </span>
    <span v-else class="text-sm text-neutral-text-weak">&ndash;</span>
  </div>
</template>

<script setup lang="ts">
import { ICellRendererParams } from '@ag-grid-community/core';
import { DateTime } from 'luxon';
import { computed } from 'vue';

const { params } = defineProps<{
  params: ICellRendererParams & {
    /** Zone to show the date in. Defaults to the viewer's local zone. */
    zone?: string;
  };
}>();

const formattedDate = computed(() => {
  if (!params.value) return null;
  return DateTime.fromISO(params.value as string, {
    zone: params.zone,
  }).toFormat('MMM d, yyyy');
});
</script>

<style lang="pcss">
@reference "../../../css/theme.css";
.table-date-cell {
  @apply flex items-center h-full w-full;
}
</style>
